module.exports = __webpack_public_path__ + "static/media/emoji_red_heart.67db9d22.svg";